export default function(model) {
    var html_template =
    '<div class="text-icon"><i class="fa-regular fa-fw fa-page tooltip" data-title="Page"></i></div>' +
    '<div>' + (model.escape('page_url') || '-') + '</div>' +

    '<div class="text-icon"><i class="fa-regular fa-fw fa-computer tooltip" data-title="System"></i></div>' +
    '<div>' + (model.getSystem() || '-') + '</div>' +

    '<div class="text-icon"><i class="fa-regular fa-fw fa-browser tooltip" data-title="Browser"></i></div>' +
    '<div>' + (model.getBrowser() || '-') + '</div>' +

    '<div class="text-icon"><i class="fa-regular fa-fw fa-arrows-maximize tooltip" data-title="Screen Size"></i></div>' +
    '<div>' +
        '<div class="margin-bottom-4">' + model.get('window_x') + ' x ' + model.get('window_y') + '<br><span class="info text-small">Browser window</span></div>' +

        (model.get('resolution_x') && model.get('resolution_y') ?
        '<div>' + model.get('resolution_x') + ' x ' + model.get('resolution_y') + '<br><span class="info text-small">Resolution</span></div>' : '') +
    '</div>' +

    '<div class="text-icon"><i class="fa-regular fa-fw fa-magnifying-glass-plus tooltip" data-title="DPI"></i></div>' +
    '<div>' + (model.escape('dpi') || '-') + '</div>' +

    '<div class="text-icon"><i class="fa-regular fa-fw fa-location-dot tooltip" data-title="Location"></i></div>' +
    '<div>' + (model.escape('location') || '-') + '</div>';

    return html_template;
}